// Renders a shape item (rectangle, ellipse, triangle, line) inside its
// absolutely-positioned wrapper. The wrapper handles position/rotation;
// this component fills 100% of that wrapper.
export default function MoodboardShape({ item }) {
  const fill = item.fill || "#C27A62";
  const stroke = item.stroke || "#1c1b17";
  const strokeWidth = item.stroke_width ?? 0;
  const opacity = item.opacity ?? 1;

  if (item.shape === "rectangle") {
    return (
      <div
        className="w-full h-full"
        style={{
          background: fill,
          border:
            strokeWidth > 0 ? `${strokeWidth}px solid ${stroke}` : "none",
          borderRadius: `${item.corner_radius ?? 0}px`,
          opacity,
        }}
      />
    );
  }

  if (item.shape === "ellipse") {
    return (
      <div
        className="w-full h-full"
        style={{
          background: fill,
          border:
            strokeWidth > 0 ? `${strokeWidth}px solid ${stroke}` : "none",
          borderRadius: "50%",
          opacity,
        }}
      />
    );
  }

  if (item.shape === "triangle") {
    return (
      <svg
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
        className="w-full h-full block"
        style={{ opacity }}
      >
        <polygon
          points="50,4 96,96 4,96"
          fill={fill}
          stroke={strokeWidth > 0 ? stroke : "none"}
          strokeWidth={strokeWidth}
          strokeLinejoin="round"
          vectorEffect="non-scaling-stroke"
        />
      </svg>
    );
  }

  if (item.shape === "line") {
    const sw = Math.max(strokeWidth || 4, 1);
    return (
      <svg
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
        className="w-full h-full block overflow-visible"
        style={{ opacity }}
      >
        <line
          x1="0"
          y1="50"
          x2="100"
          y2="50"
          stroke={stroke}
          strokeWidth={sw}
          strokeLinecap="round"
          vectorEffect="non-scaling-stroke"
        />
      </svg>
    );
  }

  return null;
}
